<script>
    import { createEventDispatcher } from "svelte";
    import { fade, scale } from 'svelte/transition';

    const dispatch = createEventDispatcher();

    export let isModalOpen = false;
    export let rawData = "";

    function closeModal() {
        isModalOpen = false;
        dispatch('close');
    }

    // Format the JSON string to be more readable 
    $: formattedData = rawData ? JSON.stringify(JSON.parse(rawData), null, 2) : "";
</script>

{#if isModalOpen}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div 
        class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm" 
        on:click={closeModal}
        transition:fade={{ duration: 200 }}
    >
        <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75"></div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div 
            class="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-lg w-full max-w-xl relative z-60" 
            on:click|stopPropagation
            transition:scale={{ duration: 400, start: 0.95 }}
        >
            <button 
                class="absolute top-2 right-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200" 
                on:click={closeModal}
            >&times;</button>
            
            <h2 class="text-m text-gray-600 dark:text-gray-200 font-bold mb-4">Raw Data</h2>
            <pre class="text-xs text-gray-600 dark:text-gray-200 whitespace-pre-wrap overflow-auto max-h-96">{formattedData}</pre>
        </div>
    </div>
{/if}